"use client";

import React, { useMemo } from "react";
import Image from "next/image";
import { processBlogContent } from "@/utils/blog/processBlogContent";
import "@/styles/blog-content.css";
import { sanitizeBlogBannerImageUrl } from "@/lib/utils";

interface DescriptionExtendProps {
  blogContentData: string;
  blogBannerImage?: string | null;
}

const DescriptionExtend: React.FC<DescriptionExtendProps> = ({
  blogContentData,
  blogBannerImage,
}) => {
  const safeBlogBannerImage = useMemo(
    () => sanitizeBlogBannerImageUrl(blogBannerImage),
    [blogBannerImage],
  );

  const processedContent = useMemo(
    () => processBlogContent(blogContentData),
    [blogContentData],
  );

  return (
    <div className="flex flex-col justify-center items-center">
      {safeBlogBannerImage ? (
        <Image
          src={safeBlogBannerImage}
          alt="blog-header-image"
          className="rounded-xl mb-4 w-full h-auto"
          width={1200}
          height={527}
          priority
          fetchPriority="high"
          quality={75}
          sizes="(max-width: 768px) 600px, 1200px"
        />
      ) : null}
      <div className="relative flex flex-col md:flex-row">
        <div
          className="blog-content max-w-full overflow-x-auto break-words"
          style={{ wordBreak: "break-word" }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: processedContent }}
        />
      </div>
    </div>
  );
};

export default DescriptionExtend;
